import { render, staticRenderFns } from "./OtherOfficeMessages.vue?vue&type=template&id=3aba3370&scoped=true&lang=pug"
import script from "./OtherOfficeMessages.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessages.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessages.vue?vue&type=style&index=0&id=3aba3370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba3370",
  null
  
)

export default component.exports